import { PlusOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import { get, range } from "lodash";
import { useTranslation } from "react-i18next";
import { BiTrash } from "react-icons/bi";
import AlternativeMedicine from "shared/assets/images/ayurveda.png";
import Dental from "shared/assets/images/dental-checkup.png";
import Equipment from "shared/assets/images/hearing-aid.png";
import Hospitalization from "shared/assets/images/hospital-bed.png";
import MedicalCare from "shared/assets/images/medical-team.png";
import Optical from "shared/assets/images/vision.png";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import Popover from "shared/components/Popover";
import Select from "shared/components/Select";
import Slider from "shared/components/Slider";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { COVERAGE_NEEDS, PROFILE_LIST } from "utils/constants";

const Recommendation = ({
  needs,
  recommendationRules,
  setFieldValue,
  translation,
}) => {
  const PROFILES_TRANSLATION = get(translation, "RECOMMENDATION.PROFILES", {});

  const profiles = get(recommendationRules, "profiles", []);

  const selectedProfileValues = profiles.map((p) => p.value);

  const profileOptions = Object.entries(PROFILE_LIST)
    .filter(([, value]) => !selectedProfileValues.includes(value))
    .map(([key, value]) => ({
      value,
      label: get(PROFILES_TRANSLATION, `OPTIONS.${key}`, key),
    }));

  const handleAddProfile = () => {
    setFieldValue("recommendationRules.profiles", [
      ...profiles,
      { value: "", weight: 1 },
    ]);
  };

  const handleRemoveProfile = (index) => {
    const updated = profiles.filter((_, i) => i !== index);
    setFieldValue("recommendationRules.profiles", updated);
  };

  const handleProfileChange = (index, field, value) => {
    const updated = profiles.map((entry, i) =>
      i === index ? { ...entry, [field]: value } : entry,
    );
    setFieldValue("recommendationRules.profiles", updated);
  };

  return (
    <div>
      <h4 className="m-bottom-16">{PROFILES_TRANSLATION.TITLE}</h4>
      {profiles.map((entry, index) => (
        <Row
          key={index}
          gutter={[16, 16]}
          align="middle"
          className="m-bottom-8"
        >
          <Col span={10}>
            <Select
              options={[
                ...(entry.value
                  ? [
                      {
                        value: entry.value,
                        label: get(
                          PROFILES_TRANSLATION,
                          `OPTIONS.${entry.value}`,
                          entry.value,
                        ),
                      },
                    ]
                  : []),
                ...profileOptions,
              ]}
              placeholder={PROFILES_TRANSLATION.PLACEHOLDER}
              label={PROFILES_TRANSLATION.PROFILE}
              value={entry.value || undefined}
              onChange={(value) => handleProfileChange(index, "value", value)}
            />
          </Col>
          <Col span={10}>
            <Input
              min={1}
              type="number"
              placeholder={PROFILES_TRANSLATION.WEIGHT}
              label={PROFILES_TRANSLATION.WEIGHT}
              value={entry.weight}
              onChange={(e) => {
                const raw = Number(e.target.value);
                handleProfileChange(index, "weight", raw < 1 ? 1 : raw);
              }}
            />
          </Col>
          <Col span={4} className="d-flex align--center">
            <Button
              type="danger--link"
              onClick={() => handleRemoveProfile(index)}
            >
              <BiTrash size={18} />
            </Button>
          </Col>
        </Row>
      ))}
      <Button type="primary--link" onClick={handleAddProfile}>
        <PlusOutlined color={COLORS.C_WHITE} />
        {PROFILES_TRANSLATION.ADD}
      </Button>
    </div>
  );
};

export default Recommendation;
